export default __webpack_public_path__ + "static/banner-seo-63fe41c6132105e15d21ed6edab797fc.webp";